import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-details-modal-body" }
const _hoisted_2 = { class: "upper-body" }
const _hoisted_3 = {
  key: 0,
  class: "date-title"
}
const _hoisted_4 = { class: "vertical-container" }
const _hoisted_5 = { class: "date-title" }
const _hoisted_6 = { class: "vertical-container" }
const _hoisted_7 = { class: "vertical-container" }
const _hoisted_8 = {
  key: 2,
  class: "order-checkbox-show-details"
}
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { for: "showDetailsOnInvoice" }
const _hoisted_11 = { class: "lower-body" }
const _hoisted_12 = { class: "order-line-header role" }
const _hoisted_13 = { class: "order-line-header quantity" }
const _hoisted_14 = { class: "order-line-header hourly-rate" }
const _hoisted_15 = { class: "order-line-header subtotal" }
const _hoisted_16 = { class: "total" }
const _hoisted_17 = { class: "total-number" }
const _hoisted_18 = {
  key: 0,
  class: "order-checkbox-agreement"
}
const _hoisted_19 = { for: "legalNoticeAgreement" }
const _hoisted_20 = {
  key: 1,
  class: "approval-error"
}
const _hoisted_21 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_OrderLine = _resolveComponent("OrderLine")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.order)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _ctx.closeModal,
        size: "lg-fixed",
        class: "order-details"
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.order.title), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FormItem, {
                input: _ctx.orderForm.title,
                "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderForm.title) = $event)),
                errors: _ctx.v$.title.$errors,
                label: _ctx.t(`labels.order.title`),
                name: "order-title",
                readOnly: !_ctx.canEdit
              }, null, 8, ["input", "errors", "label", "readOnly"]),
              (!_ctx.isSingleMonthOrder || _ctx.canEdit || _ctx.canChangeDates)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t("labels.recurringOrder.firstMonth")) + " : ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormItem, {
                  input: _ctx.orderForm.startYear,
                  "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderForm.startYear) = $event)),
                  errors: _ctx.v$.startYear.$errors,
                  label: _ctx.t(`labels.order.year`),
                  options: _ctx.years,
                  name: "order-start-year",
                  readOnly: !_ctx.canEdit && !_ctx.canChangeDates
                }, null, 8, ["input", "errors", "label", "options", "readOnly"]),
                _createVNode(_component_FormItem, {
                  input: _ctx.orderForm.startMonth,
                  "onUpdate:input": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderForm.startMonth) = $event)),
                  errors: _ctx.v$.startMonth.$errors,
                  label: _ctx.t(`labels.order.month`),
                  options: _ctx.months,
                  name: "order-start-month",
                  readOnly: !_ctx.canEdit && !_ctx.canChangeDates
                }, null, 8, ["input", "errors", "label", "options", "readOnly"])
              ]),
              (!_ctx.isSingleMonthOrder || _ctx.canEdit || _ctx.canChangeDates)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("labels.recurringOrder.lastMonth")) + " : ", 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_FormItem, {
                        input: _ctx.orderForm.endYear,
                        "onUpdate:input": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderForm.endYear) = $event)),
                        errors: _ctx.v$.endYear.$errors,
                        label: _ctx.t(`labels.order.year`),
                        options: _ctx.years,
                        name: "order-end-year",
                        readOnly: !_ctx.canEdit && !_ctx.canChangeDates
                      }, null, 8, ["input", "errors", "label", "options", "readOnly"]),
                      _createVNode(_component_FormItem, {
                        input: _ctx.orderForm.endMonth,
                        "onUpdate:input": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderForm.endMonth) = $event)),
                        errors: _ctx.v$.endMonth.$errors,
                        label: _ctx.t(`labels.order.month`),
                        options: _ctx.months,
                        name: "order-end-month",
                        readOnly: !_ctx.canEdit && !_ctx.canChangeDates
                      }, null, 8, ["input", "errors", "label", "options", "readOnly"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FormItem, {
                  input: _ctx.orderForm.paymentOption,
                  "onUpdate:input": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderForm.paymentOption) = $event)),
                  errors: _ctx.v$.paymentOption.$errors,
                  label: _ctx.t(`labels.order.paymentOption`),
                  options: _ctx.paymentOptions,
                  name: "order-payment-options",
                  readOnly: !_ctx.canChangePaymentMethod
                }, null, 8, ["input", "errors", "label", "options", "readOnly"]),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "fill-empty-space" }, null, -1)),
                _createVNode(_component_FormItem, {
                  input: _ctx.orderForm.companyId,
                  "onUpdate:input": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderForm.companyId) = $event)),
                  errors: _ctx.v$.companyId.$errors,
                  label: _ctx.t(`labels.order.company`),
                  options: _ctx.project.client.companies,
                  name: "order-company",
                  readOnly: !_ctx.canEdit
                }, null, 8, ["input", "errors", "label", "options", "readOnly"]),
                (_ctx.orderForm.paymentOption === 'pre_paid')
                  ? (_openBlock(), _createBlock(_component_FormItem, {
                      key: 0,
                      input: _ctx.orderForm.dueDate,
                      "onUpdate:input": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderForm.dueDate) = $event)),
                      label: _ctx.t(`labels.order.dueDate`),
                      name: "order-dueDate",
                      readOnly: !_ctx.canEdit,
                      "input-type": "date",
                      "date-markers": _ctx.dueDateMarkers
                    }, null, 8, ["input", "label", "readOnly", "date-markers"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasAdminAccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      readonly: !_ctx.canEdit,
                      type: "checkbox",
                      id: "showDetailsOnInvoice",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showDetailsOnInvoice) = $event))
                    }, null, 8, _hoisted_9), [
                      [_vModelCheckbox, _ctx.showDetailsOnInvoice]
                    ]),
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t(`labels.order.showDetailsOnInvoice`)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t("labels.order.roles")), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t("labels.order.quantity")), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("labels.order.hourlyRate")), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t("labels.order.subtotal")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.orderLines, (orderLine, index) => {
                  return (_openBlock(), _createBlock(_component_OrderLine, {
                    key: index,
                    projectRoleName: orderLine.projectRoleName,
                    hourlyRate: orderLine.hourlyRate,
                    subtotal: _ctx.orderLines[index].subtotal,
                    "onUpdate:subtotal": ($event: any) => ((_ctx.orderLines[index].subtotal) = $event),
                    quantity: _ctx.orderLines[index].quantity,
                    "onUpdate:quantity": ($event: any) => ((_ctx.orderLines[index].quantity) = $event),
                    unit: _ctx.orderLines[index].unit,
                    "onUpdate:unit": ($event: any) => ((_ctx.orderLines[index].unit) = $event),
                    readOnly: !_ctx.canEdit
                  }, null, 8, ["projectRoleName", "hourlyRate", "subtotal", "onUpdate:subtotal", "quantity", "onUpdate:quantity", "unit", "onUpdate:unit", "readOnly"]))
                }), 128))
              ]),
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.t("labels.order.total")) + " ", 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatPrice(_ctx.totalPrice)), 1)
              ]),
              _createVNode(_component_FormItem, {
                input: _ctx.orderForm.notes,
                "onUpdate:input": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderForm.notes) = $event)),
                label: _ctx.t(`labels.order.notes`),
                name: "order-notes",
                readOnly: !_ctx.canEdit,
                "input-type": "textArea"
              }, null, 8, ["input", "label", "readOnly"]),
              _createVNode(_component_FormItem, {
                input: _ctx.orderForm.legalNotice,
                "onUpdate:input": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderForm.legalNotice) = $event)),
                label: _ctx.t(`labels.order.legalNotice`),
                name: "order-legalNotice",
                readOnly: !_ctx.canEdit,
                "input-type": _ctx.textArea
              }, null, 8, ["input", "label", "readOnly", "input-type"]),
              (
              _ctx.order.isFirstOrder &&
              _ctx.hasClientAccess &&
              ['to_validate', 'late_approval'].includes(_ctx.order.status)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "legalNoticeAgreement",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.legalNoticeAgreement) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.legalNoticeAgreement]
                    ]),
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t(`labels.order.legalNoticeAgreement`)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showApproveValidation)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.t("legalNoticeAgreementError")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (
          _ctx.loading ||
          _ctx.loadingApproval ||
          _ctx.loadingSendOrder ||
          _ctx.loadingDeleteOrder ||
          _ctx.loadingUpdateOrder ||
          _ctx.loadingClosing
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.t("loading")), 1))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          (
          _ctx.hasClientAccess &&
          ['to_validate', 'late_approval'].includes(_ctx.order.status)
        )
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 0,
                onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.approveOrder()), ["prevent"])),
                color: "neutral",
                disabled: _ctx.loadingApproval,
                class: "order-details-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("buttons.order.approve")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.hasAdminAccess && ['draft', 'ready'].includes(_ctx.order.status))
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 1,
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.sendOrder()), ["prevent"])),
                disabled: 
          _ctx.loadingSendOrder ||
          _ctx.loadingDeleteOrder ||
          _ctx.loadingUpdateOrder ||
          _ctx.loadingClosing
        ,
                class: "order-details-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("buttons.order.send")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.canEdit || _ctx.canChangeDates)
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 2,
                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.updateOrder()), ["prevent"])),
                color: "neutral",
                disabled: 
          _ctx.loadingSendOrder ||
          _ctx.loadingDeleteOrder ||
          _ctx.loadingUpdateOrder ||
          _ctx.loadingClosing
        ,
                class: "order-details-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("buttons.order.update")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.canDelete)
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 3,
                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.deleteOrder()), ["prevent"])),
                color: "neutral",
                disabled: 
          _ctx.loadingSendOrder ||
          _ctx.loadingDeleteOrder ||
          _ctx.loadingUpdateOrder ||
          _ctx.loadingClosing
        ,
                class: "order-details-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("buttons.order.delete")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (
          _ctx.hasAdminAccess &&
          [
            'approved',
            'retainer_sent',
            'retainer_reminder_1',
            'retainer_reminder_2',
            'retainer_paid',
          ].includes(_ctx.order.status)
        )
            ? (_openBlock(), _createBlock(_component_BasicButton, {
                key: 4,
                onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.closeOrder()), ["prevent"])),
                disabled: 
          _ctx.loadingSendOrder ||
          _ctx.loadingDeleteOrder ||
          _ctx.loadingUpdateOrder ||
          _ctx.loadingClosing
        ,
                class: "order-details-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("buttons.order.close")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}